<template>
  <transition name="pa-simple-fade">
    <div class="pa-tokei-modal-list" v-if="isOpen" ref="modalList">
      <pull-to
       :is-top-bounce="false"
       :is-bottom-bounce="isEnableBottomBounce"
       :bottom-config="pullToBottomConfig"

       :bottom-load-method="handleRefresh"
      >
        <ul class="pa-ul">
          <li v-for="infomation in infomationList" :key="infomation.id" @click.prevent="handleSelectInfomation(infomation.id)">
            <PATimesInfomationCard
            :infomationId="infomation.id"
            />
          </li>
        </ul>

        <PATimesFetchButton
         :isLoading="isLoadingFetchButton"
         @handleClick="handleClick"
        />

        <template slot="bottom-block" slot-scope="props">
          <div class="bottom-load-wrapper">
            <!-- https://github.com/stackjie/vue-pull-to/blob/779e7a202be15943b724f4bc7ad383b0027123ed/examples/pages/SimplePullToLoadMore.vue -->
            <template v-if="props.state === 'loading'">
              <PuffLoadingImage class="waiting-loader" stroke="#B76084" />
            </template>
            <template v-else>
              {{ props.stateText }}
            </template>
          </div>
        </template>
      </pull-to>
    </div>
  </transition>
</template>

<script>
import PullTo from 'vue-pull-to'
import PuffLoadingImage from '@/components/Parts/PATimesModal/images/puff.svg?inlineN'

import PATimesInfomationCard from '@/components/Parts/PATimesModal/Parts/PATimesInfomationCard'
import PATimesFetchButton    from '@/components/Parts/PATimesModal/Parts/PATimesFetchButton'

import {GetInfomation, GetInfomationList} from '@/graphql/queries/Infomation.graphql'

export default {
  props       : {
    isOpen : {
      default: false
    },

    contentHeight : {
      default:0
    },

    // isEnableBottomBounce  : {
    //   default:false
    // }
  },

  components  : {
    PullTo,
    PuffLoadingImage,
    PATimesInfomationCard,
    PATimesFetchButton
  },

  data(){
    return {
      infomationList      : [],
      
      first               : 10,
      page                : 1,

      pullToBottomConfig  : {
        pullText        : 'ひっぱって続き',
        triggerText     : '離して更新',
        loadingText     : '更新中',
        doneText        : '',
        failText        : '更新失败',
        loadedStayTime  : 0,
        stayDistance    : 50,
        triggerDistance : 70
      },

      // Propsに移動します。
      isEnableBottomBounce : false,

      isLoadingFetchButton  : false,
    }
  },

  apollo : {
    infomations : {
      query : GetInfomationList,
      
      variables(){
        return {
          first   : this.first,
          page    :  this.page,
          orderBy : [
            {
              // field : 'id',
              column : 'id',
              order : 'DESC'
            }
          ]
        }
      },

      result({data: {infomations: {data}}}){

        const apolloClient = this.$apollo.provider.defaultClient;

        for(let infomation of data){
          apolloClient.writeQuery({
            query     : GetInfomation,
            variables : {
              id  : infomation.id
            },
            data      : {
              infomation : infomation
            }
          });
        }
      },
      
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      },

      fetchPolicy: 'no-cache'
    }
  },

  computed : {
    isLoadingData(){
      if(typeof this.$apollo.queries.infomations === 'undefined') return false;

      return this.$apollo.queries.infomations.loading;
    }
  },

  watch : {
    infomations : {
      handler(data){
        if(typeof data === 'undefined') return;

        this.insertInfomationList(data);

        this.checkHasUnReadInfomation(data);

        this.$nextTick(() => {
          this.initializeHandleScroll();
        });
      },
      immediate: true
    },

    isLoadingData(value){
      this.$store.dispatch({
        type  : 'paTimesModal/updateIsLoadingModal',
        value : value
      });
    }
  },

  methods : {
    checkHasUnReadInfomation(data){
      let hasUnreadedInfomation = false;

      for(let infomation of data.data){
        if(infomation.characterReaded === false){
          hasUnreadedInfomation = true;
          break;
        }
      }

      this.$store.dispatch({
        type  : 'paTimesModal/updateHasUnreadedInfomation',
        value : hasUnreadedInfomation
      });
    },

    insertInfomationList(data){
      const parameters = {
        requestBehaviour  : 'next',
        infomationList    : [],

        pageSet           : {
          page        : null,
          lastPage    : null,
          total       : null,
        }
      };

      if(this.page === 1){
        parameters.requestBehaviour = 'refresh';
      }

      for(let infomation of data.data){
        parameters.infomationList.push({
          id  : infomation.id
        });
      }

      if(typeof data.paginatorInfo !== 'undefined'){
        parameters.pageSet.page     = data.paginatorInfo.currentPage;
        parameters.pageSet.lastPage = data.paginatorInfo.lastPage;
        parameters.pageSet.total    = data.paginatorInfo.total;
      }

      if(parameters.requestBehaviour === 'refresh'){
        this.infomationList = parameters.infomationList;
      }else{
        for(let infomation of parameters.infomationList){
          let couldRegist = true;

          for(let registerdInfomation of this.infomationList){
            if(registerdInfomation.id === infomation.id){
              couldRegist = false;
            }
          }

          if(couldRegist){
            this.infomationList.push({
              id  : infomation.id
            });
          }
        }
      }
    },

    async handleRefresh(loaded){
      const requestNextPage = this.page + 1;
      
      // ページがオーバーしていなければOK
      if( this.infomations.paginatorInfo.lastPage >= requestNextPage ){
        await this.UXWaiting(1000);

        // console.log(this.infomations.paginatorInfo.lastPage);

        this.page = requestNextPage;
      }

      loaded('done');
    },

    async handleClick(){
      this.isLoadingFetchButton = true;
      
      await this.UXWaiting(800);

      const requestNextPage = this.page + 1;
      
      // ページがオーバーしていなければOK
      if( this.infomations.paginatorInfo.lastPage >= requestNextPage ){
        this.page = requestNextPage;
      }

      this.isLoadingFetchButton = false;
    },

    handleSelectInfomation(infomationId){
      const newUrlQuery = Object.assign({}, this.$route.query);

      newUrlQuery['infomation_id'] = infomationId;

      this.$router.push({
        name    : this.$route.name,
        params  : this.$route.params,
        query   : newUrlQuery
      });
    },

    handleListScroll(){
      if(typeof this.$refs.modalList === 'undefined') return;

      if( this.$refs.modalList.offsetHeight <= (this.$parent.$refs.content.scrollTop + this.contentHeight) ){
        this.isEnableBottomBounce = true;
      }else{
        this.isEnableBottomBounce = false;
      }
    },

    initializeHandleScroll(){
      this.$parent.$refs.content.removeEventListener('scroll', this.handleListScroll);
      this.$parent.$refs.content.addEventListener('scroll', this.handleListScroll);

      // // 最初のイベントを発行します。
      this.handleListScroll(); 
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.vue-pull-to-wrapper{
  color:#B76084;
  height:100%;
}

.bottom-load-wrapper{
  margin-top:.5rem;
  text-align: center;
}

.pa-tokei-modal-list{
  padding-bottom:.5rem;

  ul.pa-ul{
    width:94%;
    margin:0 auto;
    margin-bottom:.3rem !important;
    padding:.3rem 0 0;
    color:#cccccc;
    
    li{
      list-style-type: none;

      margin-top:.9rem;
      border-bottom:1px solid #7F3356;
    }
  }

  @media screen and (min-width: $desktop) {
    max-width:750px;
    padding:0 12px;
    margin:20px auto;

    li{
      margin-top:16px;
      border-bottom:1.5px solid #7F3356;

      p.main-text, p.sub-text{
        font-size:1.2rem;
      }

      p.sub-text{
        font-size:1rem;
      }
    }
  }
}
</style>